// extracted by mini-css-extract-plugin
export default {"label":"Text_label__F2wFl","content":"Text_content__F-v-x","container":"Text_container__X1Gyc"};